import AppRecord from './AppRecord.js'
import APP from '../../../main.js'

class IssueFundGroup extends AppRecord {

}
export default IssueFundGroup
